
<div class="modal-header pl-0 pt-0 pb-1">
    <h5 class="modal-title" style="color: #1C3B7B !important;">Proceso de timbrado completado exitosamente.</h5>
    <button type="button" class="boton-cerrar" aria-label="Close" (click)="cerrar()">
        <span aria-hidden="true">&times;</span>
    </button>
    <!-- <a href="javascript:void(0)" class="card-link float-right" (click)="cerrar()"><mat-icon aria-hidden="false" aria-label="Example home icon">close</mat-icon></a> -->
</div>
<div class="modal-body pt-1 pr-0 pb-6 pl-0">
    <br>
    <p class=""> {{ data.error.mensaje }}</p>
</div>
<div class="card-footer border-0 pt-0 pl-0 pb-0" style="background-color: white;">
    <div class="row">
        <div class="col-sm-3">
            <!-- <ngb-alert [dismissible]="false" type="danger">
                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="mr-2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                Error al facturar
            </ngb-alert> -->

            <div class="alert alert-success" role="alert">
                Timbrado exitoso
              </div>
        </div>
        <div class="col-sm-9">
            <!-- <button type="button" class="btn btn-rounded btn-primary float-right" (click)="enviar();" *ngIf="showBtnEnviarInforme">
                <span class="btn-icon-left text-primary"><i class="fa fa-paper-plane" aria-hidden="true"></i></span> Enviar informe
            </button> -->

            <!-- <a href="javascript:void(0)" class="btn btn-sm btn-primary mr-2 mt-1 float-right" (click)="accionar(); ">  *ngIf="detalle.length == 0"
                Enviar informe <i class="material-icons">send</i>
            </a> -->

            <!-- <button  type="button"
            class="btn btn-rounded tp-btn-light btn-primary float-right mr-2"
            mat-flat-button (click)="dowload('pdf')">
                <mat-icon [svgIcon]="'file_download'"></mat-icon>
            </button> -->

            <!-- <button  type="button"
            class="btn btn-rounded tp-btn-light btn-primary float-right mr-2"
            mat-flat-button (click)="dowload('xml')">
                <mat-icon [svgIcon]="'file_download'"></mat-icon>
            </button> -->

            <button type="button" class="btn btn-rounded tp-btn-light btn-primary float-right mr-2" (click)="cerrar(); ">
                Cerrar
            </button>
            <button type="button" class="btn btn-rounded tp-btn-light btn-warning float-right mr-2" (click)="enviarCorreo(); ">
                Enviar por correo
            </button>

            <button type="button" class="btn btn-rounded tp-btn-light btn-danger float-right mr-2" (click)="dowload('pdf'); ">
                Descargar PDF
            </button>

            <button type="button" class="btn btn-rounded tp-btn-light btn-success float-right mr-2" (click)="dowload('xml'); ">
                Descargar XML
            </button>



            <!-- <button type="button" class="btn btn-rounded tp-btn-light btn-primary float-right mr-2" (click)="accionar(); ">
                <span class="btn-icon-left text-primary">
                    <i class="fa fa-angle-down" aria-hidden="true" *ngIf="visibleError"></i>
                    <i class="fa fa-angle-up" aria-hidden="true" *ngIf="!visibleError"></i>
                </span> {{ ( visibleError ) ? 'Mostrar más' : 'Mostrar menos' }}
            </button> -->
            <!-- <a href="javascript:void(0)" class="btn btn-sm btn-outline-primary mr-2 mt-1 float-right" (click)="accionar(); ">

            </a> -->
        </div>
    </div>
</div>

<div class="card mt-2" [ngClass]="{'ocultar': visibleError}">
    <div class="card-body">
        <table class="table table-sm">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Criterio</th>
                    <th scope="col">Mensaje</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of detalle; let i = index">
                    <th scope="row">{{ i + 1 }}</th>
                    <td>{{ item.Key }}</td>
                    <td>{{ item.Value }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>




<!-- <div class="cardHeader">
    <div class="container">
        <span class="float-right">
            <mat-card-title class='icono punter'>
                <mat-icon class="s-20" (click)='cerrar()'>close</mat-icon>
            </mat-card-title>
        </span>
        <mat-card-title>La operación no pudo ser procesada.</mat-card-title>
    </div>
</div>
<mat-card-content>
    <p class="contenido">
        El sistema no ha funcionado correctamente, hemos recabado la información relacionada con este incidente. Para
        generar un ticket al equipo de soporte de clic en el botón “Enviar Informe”, daremos seguimiento a su solicitud.
    </p>
</mat-card-content>
<div class="container text-center">
    <div class="row">
        <div class="col-12 col-sm-12 col-md-4 col-lg-4">
            <div class=" bordes tipo warn">
                <span class="tipo">Servicio</span>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4">
            <div class=" bordes1 tipo2 fuse-navy-600" (click)='enviar()'>
                <span>Enviar Informe</span>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4">
            <button class="btn btn-sm btn-outline-primary mr-2" (click)="acc.toggle('toggle-1')">Toggle first</button>
        </div>
    </div>
</div>

<ngb-accordion #acc="ngbAccordion">
    <ngb-panel id="toggle-1" title="First panel" cardClass="default-accordion">
        <ng-template ngbPanelContent>
            <pre> Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.</pre>
        </ng-template>
    </ngb-panel>
</ngb-accordion>

  <hr/>
   -->
  <!-- <button class="btn btn-sm btn-outline-primary mr-2" (click)="acc.toggle('toggle-1')">Toggle first</button>
  <button class="btn btn-sm btn-outline-primary mr-2" (click)="acc.toggle('toggle-2')">Toggle second</button> -->
